var request = require('../request');
var requestV2 = require('../requestV2');
var executeWithRetry = require('../utils/retry');
var logger = require('../logger');
var { MAX_RETRIES, RETRY_DELAY } = require('../constants/retry');

var RESOURCE_MANAGEMENT_API_PATH = '/microapi/resourcemgt';

function transformParams(params) {
    var opts = [];
    for (var key in params) {
        opts.push({
            key: (key || '').toString(),
            value: (params[key] || '').toString(),
        });
    }
    return {
        data: JSON.stringify({ opts: opts }),
    };
}

/**
 * 获取对象上传路径和临时密钥
 * @param {string} media_type - 资源业务类型：audio | image | imagefulltext | imagewall | imageweike | video | videoweike | docweike | picweike | weike2video | studentexam | studentavatar | video2audio | ailogfile | graffiti
 * @param {string} id_prefix - 用户类型：enterprise | session | student | teacher | helpcenter
 * @param {string} id - 用户id, （如果没有用户怎么办？）
 * @param {string} ext - 资源后缀（可能没有）
 * @param {string} file_name - 文件名称
 * @returns {Promise} {resource_id, object_name, ICredentialInfo, IBucketInfo}
 *
 */
function getBucketInfoAndCredentialInfo(params) {
    return request.post(RESOURCE_MANAGEMENT_API_PATH + '/preObject', transformParams(params)).then(
        function (response) {
            return response;
        },
        function (e) {
            logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo error', e, params);
        }
    );
}

/**
 * 获取对象上传临时密钥
 * @param {string} resource_id - <string objPathAuth 或者objPathToken接口中获取的resource_id>
 * @param {string} cred_type - token | preSign
 * @returns {Promise} ICredentialInfo
 */
function getCredentialInfo(params) {
    return request.post(RESOURCE_MANAGEMENT_API_PATH + '/preObjectCredential', transformParams(params)).then(
        function (response) {
            return response;
        },
        function (e) {
            logger.error('[umu-upload cos] getCredentialInfo error', e);
        }
    );
}

/**
 * 完成对象上传后回调
 * @param {string} media_type - 用户id
 * @param {string} resource_id - 资源id
 * @param {string} ext??? - 文件名称
 * @param {string} file_name? - 文件名称
 * @param {string} file_size? -
 * @param {string} file_duration? - 文件名称
 * @param {string} extend_info? - 其他参数
 * @returns {Promise}  resource_id
 */
function callbackOnObjectUploaded(params) {
    var postData = {
        data: JSON.stringify(params),
    };
    return request.post(RESOURCE_MANAGEMENT_API_PATH + '/resourceCallback', postData).then(
        function (response) {
            return response;
        },
        function (e) {
            logger.error('[umu-upload cos] callbackOnObjectUploaded error', e, postData);
        }
    );
}

/**
 * 刷新上传凭证
 * @param {string} resource_id - 从 GenObjPathWithCredential 返回的 resource_id
 * @param {string} cred_type - 固定使用 token
 * @returns {Promise} {credential_info}
 * 使用场景：凭证过期续期、断点续传
 */
function getObjectToken(params) {
    return request.postJson(RESOURCE_MANAGEMENT_API_PATH + '/preObjectCredential', params).then(
        function (response) {
            return response;
        },
        function (e) {
            logger.error('[umu-upload cos] getObjectToken error', e, params);
        }
    );
}

function callbackOnObjectUploadedV2(params) {
    var postData = {
        data: JSON.stringify(params),
    };
    return executeWithRetry(
        async () => {
            return requestV2
                .post(RESOURCE_MANAGEMENT_API_PATH + '/resourceCallback', postData)
                .then(function (response) {
                    return response;
                });
        },
        { retries: MAX_RETRIES, retryDelay: RETRY_DELAY, taskName: 'callbackOnObjectUploadedV2' }
    ).catch(function (e) {
        logger.error('[umu-upload cos] callbackOnObjectUploadedV2 error', e, postData);
        throw e;
    });
}

module.exports = {
    getBucketInfoAndCredentialInfo: getBucketInfoAndCredentialInfo,
    getCredentialInfo: getCredentialInfo,
    callbackOnObjectUploaded: callbackOnObjectUploaded,
    getObjectToken: getObjectToken,
    callbackOnObjectUploadedV2: callbackOnObjectUploadedV2,
};
